import { render, staticRenderFns } from "./RptResumenClientes.vue?vue&type=template&id=50dc5e07&"
import script from "./RptResumenClientes.vue?vue&type=script&lang=js&"
export * from "./RptResumenClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports